import React from 'react';
import Plot from 'react-plotly.js';
import { mergeLayout, PLOTLY_CONFIG } from './chartTheme';
import { useTheme } from '../../context/ThemeContext';

const PlotlyChart = ({ data, layout = {}, config = {}, style = {}, interactive, ...props }) => {
  const { theme } = useTheme();
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  // On mobile: static by default, unless `interactive` prop is true (e.g. heatmaps)
  const mobileConfig = (isMobile && !interactive) ? { staticPlot: true } : {};

  return (
    <div className="w-full overflow-hidden">
      <Plot
        data={data}
        layout={mergeLayout(layout, theme)}
        config={{ ...PLOTLY_CONFIG, ...config, ...mobileConfig }}
        useResizeHandler
        style={{ width: '100%', minHeight: isMobile ? 250 : 350, ...style }}
        {...props}
      />
    </div>
  );
};

export default PlotlyChart;
